// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".introducer_table table td[data-v-0f45c6e0]{text-align:center}.introducer_table .v-data-footer__select[data-v-0f45c6e0]{display:none}.rate[data-v-0f45c6e0]{font-weight:700}.trigger[data-v-0f45c6e0]{color:#696969;font-size:10px}", ""]);
// Exports
module.exports = exports;
